import { render, staticRenderFns } from "./RoutingStaticForm.vue?vue&type=template&id=63c0e328&"
import script from "./RoutingStaticForm.vue?vue&type=script&lang=js&"
export * from "./RoutingStaticForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports